import { autoinject, computedFrom } from 'aurelia-framework';
import { ValidationRules } from 'aurelia-validation';
import { WidgetController } from 'controls/as-widget-container';
import { AirlineExtendedDeviationDetail } from 'model/forms/deviation-request';
import { LookupsService } from 'services/lookups-service';
import { WidgetBase } from 'support/base_classes/widget-base';
import { KeywordsService } from 'services/keywords-service';
import { watch } from 'aurelia-watch-decorator';
import { City } from 'model/business-keywords';

@autoinject
export class AirlineExtendedDeviationDetailWidget extends WidgetBase<AirlineExtendedDeviationDetail, WidgetController> {
  constructor(private keywords: KeywordsService, private lookups: LookupsService) {
    super();
  }

  changed() {
    ValidationRules
      .ensureObject<AirlineExtendedDeviationDetail>().required()
      .ensure(model => model.airlineCustomName).displayName('Airline').required()
      .ensure(model => model.originCountry).displayName('Origin Country').required()
      .ensure(model => model.destinationCountry).displayName('Destination Country').required()
      .on(this.model);
  }

  airlinesLookupOptions = this.lookups.getAirlinesLookupOptions();
  citiesLookupOptions = this.lookups.getCitiesLookupOptions();

  @computedFrom('keywords.countries', 'model.originCountry')
  get originCountries() {
    return this.keywords.ensureItem(this.keywords.countries, this.model.originCountry);
  }

  @computedFrom('keywords.countries', 'model.destinationCountry')
  get destinationCountries() {
    return this.keywords.ensureItem(this.keywords.countries, this.model.destinationCountry);
  }

  @watch((x: AirlineExtendedDeviationDetailWidget) => x.model.originCity)
  private originCityChanged(newValue: City, oldValue: City) {
    if (this.model.originCountry == null || this.model.originCountry.id === oldValue?.country.id)
      this.model.originCountry = newValue?.country ?? null;
  }

  @watch((x: AirlineExtendedDeviationDetailWidget) => x.model.destinationCity)
  private destinationCityChanged(newValue: City, oldValue: City) {
    if (this.model.destinationCountry == null || this.model.destinationCountry.id === oldValue?.country.id)
      this.model.destinationCountry = newValue?.country ?? null;
  }
}
